// Shared UI helpers

export const humanSize = (bytes) => {
    if (!bytes && bytes !== 0) return '';
    const k = 1024;
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(k)));
    return `${(bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
};

// Route external images (himanshutanty.com/wp-content/...) through the
// backend caching proxy so we don't hit the source's HTTP/2 stream limit.
// Also, promote same-origin API paths (`/api/…`) to fully-qualified URLs
// so they resolve against the backend regardless of what page they render on.
export const proxyImg = (url) => {
    if (!url) return url;
    const base = process.env.REACT_APP_BACKEND_URL || '';
    // Same-origin API path → absolute backend URL
    if (url.startsWith('/api/')) {
        return `${base}${url}`;
    }
    // Legacy himanshutanty.com hotlinks → route through /api/img cache
    if (!/^https?:\/\/(www\.)?himanshutanty\.com\/wp-content\//i.test(url)) {
        return url;
    }
    return `${base}/api/img?u=${encodeURIComponent(url)}`;
};

